<footer class="footer_wrapper">
	<div class="container">
		<div class="row">
			<div class="col-lg-10 offset-lg-1">
				<div class="row footer_top d-flex justify-content-center">
					<div class="col-lg-4 col-md-6 col_footer_links">
						<ul class="nav">
							<li><a routerLink="/">Home</a></li>
							<li><a routerLink="/news">News</a></li>
							<li><a routerLink="/form-guide">Form Guide</a></li>
							<li><a routerLink="/liveyard">Live Yard</a></li>
							<li><a routerLink="/results">Results</a></li>
							<li><a routerLink="/jumpouts">Jump Outs</a></li>
							<li><a routerLink="/blackbook">Blackbook</a></li>
							<li><a routerLink="/resources">Resources</a></li>
							<li><a routerLink="/tournaments">Tournaments</a></li>
							<li><a routerLink="/sponsors">Sponsors</a></li>
							<li><a routerLink="/contact">Contact</a></li>
						</ul>
						<!-- end nav -->
					</div>
					<!-- end col_links -->

					<div class="col-lg-3 col-md-6 col_contact_links">
						<div class="email_wrap">
							<h5 class="link_title">Enquiries</h5>
							<a class="links" href="mailto:info@theraceclub.com.au">info@racingcentral.com.au</a>
						</div>

						<div class="social_links">
							<h5 class="link_title">Follow us</h5>
							<a class="links" href="https://www.facebook.com/theraceclub.com.au" target="_blank"> Fb </a>
							<a class="links" href="https://www.instagram.com/theraceclub.com.au/" target="_blank">
								Ig
							</a>
						</div>

						<div class="store_links d-lg-none">
							<p>Download Racing Central</p>
							<div class="play_store_links">
								<a href="https://apps.apple.com/au/app/the-race-club/id1434221878" target="_blank">
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="134.744"
											height="40.115"
											viewBox="0 0 134.744 40.115"
										>
											<g
												id="Group_9322"
												data-name="Group 9322"
												transform="translate(-88.013 53.58)"
											>
												<rect
													id="Rectangle_2577"
													data-name="Rectangle 2577"
													width="134.742"
													height="40.115"
													transform="translate(88.013 -53.58)"
													fill="none"
												/>
												<path
													id="Path_395"
													data-name="Path 395"
													d="M216.238-13.465H94.793a6.791,6.791,0,0,1-6.78-6.785V-46.8a6.787,6.787,0,0,1,6.78-6.783H216.238a6.582,6.582,0,0,1,6.518,6.646c0,.046,0,.091,0,.137v27.2c0,3.608-2.679,6.127-6.516,6.127ZM94.793-52.58a5.789,5.789,0,0,0-5.78,5.783V-20.25a5.788,5.788,0,0,0,5.78,5.784H216.238c3.3,0,5.516-2.06,5.516-5.128V-46.8a5.594,5.594,0,0,0-5.4-5.78c-.039,0-.077,0-.116,0Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
												<path
													id="Path_396"
													data-name="Path 396"
													d="M117.978-33.431a5.8,5.8,0,0,1,2.761-4.864,5.937,5.937,0,0,0-4.675-2.528c-1.966-.206-3.873,1.177-4.876,1.177-1.023,0-2.566-1.157-4.227-1.123a6.223,6.223,0,0,0-5.24,3.2c-2.267,3.923-.577,9.688,1.594,12.86,1.087,1.55,2.356,3.286,4.016,3.225,1.625-.068,2.233-1.037,4.194-1.037,1.943,0,2.512,1.038,4.207,1,1.743-.028,2.843-1.56,3.889-3.127A12.864,12.864,0,0,0,121.4-28.28a5.6,5.6,0,0,1-3.42-5.154m-3.2-9.478A5.716,5.716,0,0,0,116.088-47a5.807,5.807,0,0,0-3.758,1.945,5.427,5.427,0,0,0-1.34,3.938,4.8,4.8,0,0,0,3.792-1.793m26.716,21.2h-2.27l-1.243-3.91h-4.328l-1.185,3.91h-2.21l4.283-13.308h2.646l4.3,13.308Zm-3.889-5.55-1.125-3.474q-.177-.531-.671-2.506h-.039q-.2.849-.633,2.507l-1.1,3.476h3.574Zm14.907.635a5.458,5.458,0,0,1-1.322,3.868,3.871,3.871,0,0,1-2.943,1.263,2.938,2.938,0,0,1-2.724-1.36h-.038V-17.8h-2.137V-28.147q0-1.539-.079-3.16h1.876l.117,1.52h.041a3.8,3.8,0,0,1,5.262-1.091,3.826,3.826,0,0,1,.809.715,5.307,5.307,0,0,1,1.135,3.537Zm-2.17.077a3.966,3.966,0,0,0-.633-2.31,2.184,2.184,0,0,0-1.856-.948,2.206,2.206,0,0,0-1.43.522,2.415,2.415,0,0,0-.84,1.373,2.7,2.7,0,0,0-.1.65v1.6a2.558,2.558,0,0,0,.64,1.768,2.133,2.133,0,0,0,1.67.72,2.188,2.188,0,0,0,1.875-.927,4.106,4.106,0,0,0,.672-2.45Zm13.207-.077a5.455,5.455,0,0,1-1.324,3.868,3.868,3.868,0,0,1-2.94,1.263,2.94,2.94,0,0,1-2.725-1.36h-.04V-17.8h-2.135V-28.147q0-1.539-.081-3.16h1.878l.12,1.52h.038a3.8,3.8,0,0,1,5.262-1.092,3.836,3.836,0,0,1,.81.716,5.309,5.309,0,0,1,1.135,3.537Zm-2.172.077a3.951,3.951,0,0,0-.633-2.31,2.181,2.181,0,0,0-1.855-.948,2.21,2.21,0,0,0-1.431.522,2.414,2.414,0,0,0-.839,1.373,2.8,2.8,0,0,0-.1.65v1.6a2.554,2.554,0,0,0,.64,1.768,2.124,2.124,0,0,0,1.669.72,2.187,2.187,0,0,0,1.874-.927,4.1,4.1,0,0,0,.672-2.45Zm14.512,1.106a3.552,3.552,0,0,1-1.18,2.764,5.25,5.25,0,0,1-3.626,1.165,6.345,6.345,0,0,1-3.45-.83l.5-1.777a5.832,5.832,0,0,0,3.082.85,2.917,2.917,0,0,0,1.877-.544,1.77,1.77,0,0,0,.67-1.453,1.85,1.85,0,0,0-.553-1.364,5.151,5.151,0,0,0-1.835-1.03q-3.5-1.3-3.5-3.816a3.384,3.384,0,0,1,1.225-2.69,4.83,4.83,0,0,1,3.258-1.048,6.455,6.455,0,0,1,3.019.63l-.532,1.74a5.216,5.216,0,0,0-2.548-.613,2.564,2.564,0,0,0-1.755.553,1.581,1.581,0,0,0-.532,1.2,1.625,1.625,0,0,0,.61,1.3,6.9,6.9,0,0,0,1.936,1.027,6.547,6.547,0,0,1,2.529,1.62,3.406,3.406,0,0,1,.808,2.31m7.046-4.266h-2.354v4.66q0,1.777,1.245,1.777a3.791,3.791,0,0,0,.949-.1l.059,1.62a4.816,4.816,0,0,1-1.659.237,2.558,2.558,0,0,1-1.975-.77,3.784,3.784,0,0,1-.71-2.587v-4.828h-1.4v-1.6h1.4v-1.756l2.093-.632v2.39h2.351v1.6m10.6,3.12a5.277,5.277,0,0,1-1.263,3.633,4.514,4.514,0,0,1-3.516,1.46,4.286,4.286,0,0,1-3.365-1.4,5.1,5.1,0,0,1-1.254-3.534,5.21,5.21,0,0,1,1.295-3.654,4.47,4.47,0,0,1,3.484-1.42,4.384,4.384,0,0,1,3.4,1.4,5.07,5.07,0,0,1,1.224,3.515Zm-2.213.07a4.326,4.326,0,0,0-.572-2.278,2.109,2.109,0,0,0-1.915-1.15,2.136,2.136,0,0,0-1.954,1.15,4.395,4.395,0,0,0-.574,2.313,4.3,4.3,0,0,0,.572,2.276,2.178,2.178,0,0,0,2.948.892,2.181,2.181,0,0,0,.9-.912,4.336,4.336,0,0,0,.591-2.3Zm9.144-2.914a3.633,3.633,0,0,0-.674-.06,2.015,2.015,0,0,0-1.737.85,3.181,3.181,0,0,0-.534,1.9V-21.7H195.4l.019-6.575q0-1.659-.082-3.02h1.859l.078,1.835h.059a3.268,3.268,0,0,1,1.066-1.52,2.579,2.579,0,0,1,1.54-.513,3.2,3.2,0,0,1,.535.04v2.032m9.534,2.47a5.126,5.126,0,0,1-.076.966h-6.4a2.785,2.785,0,0,0,.927,2.173,3.167,3.167,0,0,0,2.09.669,7.1,7.1,0,0,0,2.591-.453l.333,1.48a8.024,8.024,0,0,1-3.217.592,4.653,4.653,0,0,1-3.505-1.313,4.844,4.844,0,0,1-1.274-3.526,5.5,5.5,0,0,1,1.185-3.613,4.1,4.1,0,0,1,3.357-1.538,3.573,3.573,0,0,1,3.14,1.54,5.189,5.189,0,0,1,.847,3.02Zm-2.032-.553a2.9,2.9,0,0,0-.413-1.639,1.867,1.867,0,0,0-1.7-.888,2.024,2.024,0,0,0-1.7.87,3.161,3.161,0,0,0-.629,1.657h4.442Zm-71.07-15.7a3.283,3.283,0,0,1-1.06,2.658,4.2,4.2,0,0,1-2.783.824,13.057,13.057,0,0,1-1.532-.078v-6.43a11.179,11.179,0,0,1,1.8-.137,3.9,3.9,0,0,1,2.591.747,3.031,3.031,0,0,1,.98,2.416Zm-1.107.03a2.394,2.394,0,0,0-.606-1.757,2.389,2.389,0,0,0-1.77-.61,4.509,4.509,0,0,0-.845.067v4.89a6.191,6.191,0,0,0,.708.028,2.483,2.483,0,0,0,1.858-.67,2.684,2.684,0,0,0,.655-1.95Zm6.964,1a2.593,2.593,0,0,1-.62,1.785,2.226,2.226,0,0,1-1.728.718,2.116,2.116,0,0,1-1.655-.688,2.513,2.513,0,0,1-.616-1.737,2.551,2.551,0,0,1,.636-1.794,2.2,2.2,0,0,1,1.71-.7,2.157,2.157,0,0,1,1.67.688,2.5,2.5,0,0,1,.6,1.728Zm-1.087.034a2.151,2.151,0,0,0-.281-1.12,1.036,1.036,0,0,0-.941-.563,1.049,1.049,0,0,0-.96.563,2.149,2.149,0,0,0-.282,1.138,2.114,2.114,0,0,0,.282,1.12,1.055,1.055,0,0,0,.95.564,1.043,1.043,0,0,0,.94-.574,2.116,2.116,0,0,0,.292-1.128m8.94-2.354-1.472,4.715h-.959l-.612-2.047a14.542,14.542,0,0,1-.38-1.523h-.017a11.227,11.227,0,0,1-.38,1.523l-.649,2.047h-.969l-1.389-4.715h1.077l.535,2.24c.13.53.235,1.035.32,1.513h.02q.114-.591.386-1.5l.671-2.25h.853l.639,2.2c.157.536.281,1.054.378,1.55h.031a13.878,13.878,0,0,1,.32-1.55l.572-2.2h1.025m5.436,4.712H155v-2.7q0-1.248-.95-1.248a.944.944,0,0,0-.757.343,1.21,1.21,0,0,0-.29.807v2.8h-1.049v-3.37c0-.414-.012-.863-.037-1.35h.92l.05.738h.03a1.5,1.5,0,0,1,.542-.57,1.766,1.766,0,0,1,.95-.263,1.5,1.5,0,0,1,1.1.427,2.077,2.077,0,0,1,.543,1.56v2.826m1.84-6.879h1.046v6.879h-1.046Zm7.22,4.479a2.593,2.593,0,0,1-.62,1.785,2.226,2.226,0,0,1-1.727.718,2.111,2.111,0,0,1-1.656-.688,2.507,2.507,0,0,1-.615-1.737,2.565,2.565,0,0,1,.633-1.794,2.2,2.2,0,0,1,1.71-.7,2.157,2.157,0,0,1,1.67.688,2.5,2.5,0,0,1,.6,1.728Zm-1.088.034a2.162,2.162,0,0,0-.28-1.12,1.084,1.084,0,0,0-1.472-.428,1.075,1.075,0,0,0-.428.428,2.14,2.14,0,0,0-.282,1.138,2.125,2.125,0,0,0,.281,1.12,1.055,1.055,0,0,0,.95.564,1.045,1.045,0,0,0,.941-.574A2.115,2.115,0,0,0,164.025-42.146Zm6.16,2.362h-.94l-.08-.543h-.031a1.6,1.6,0,0,1-1.375.65,1.422,1.422,0,0,1-1.076-.426,1.343,1.343,0,0,1-.37-.96,1.466,1.466,0,0,1,.724-1.32,3.754,3.754,0,0,1,2.033-.446v-.087q0-.93-.979-.93a2.174,2.174,0,0,0-1.229.35l-.212-.69a3.018,3.018,0,0,1,1.613-.4q1.848,0,1.85,1.95V-40.9a7.158,7.158,0,0,0,.068,1.124ZM169.1-41.4v-.727q-1.732-.03-1.733.95a.711.711,0,0,0,.2.553.74.74,0,0,0,.513.184,1.057,1.057,0,0,0,.639-.218.893.893,0,0,0,.364-.558,1.132,1.132,0,0,0,.016-.184Zm7.044,1.62h-.931l-.047-.757h-.031a1.564,1.564,0,0,1-1.512.864,1.763,1.763,0,0,1-1.416-.67,2.6,2.6,0,0,1-.563-1.735,2.727,2.727,0,0,1,.611-1.853,1.877,1.877,0,0,1,1.456-.66,1.417,1.417,0,0,1,1.328.64h.019v-2.7H176.1v5.607q0,.69.037,1.27m-1.087-1.99v-.785a1.583,1.583,0,0,0-.029-.33,1.192,1.192,0,0,0-.378-.635,1.026,1.026,0,0,0-.7-.258,1.073,1.073,0,0,0-.922.466,1.991,1.991,0,0,0-.336,1.193,1.857,1.857,0,0,0,.322,1.135,1.08,1.08,0,0,0,.916.467,1.017,1.017,0,0,0,.827-.388,1.305,1.305,0,0,0,.3-.865Zm10.05-.406a2.593,2.593,0,0,1-.62,1.785,2.224,2.224,0,0,1-1.729.718,2.113,2.113,0,0,1-1.653-.688,2.507,2.507,0,0,1-.615-1.737,2.557,2.557,0,0,1,.627-1.794,2.2,2.2,0,0,1,1.713-.7,2.154,2.154,0,0,1,1.667.688,2.493,2.493,0,0,1,.6,1.728Zm-1.09.034a2.162,2.162,0,0,0-.28-1.12,1.041,1.041,0,0,0-.943-.563,1.049,1.049,0,0,0-.96.563,2.14,2.14,0,0,0-.282,1.138,2.125,2.125,0,0,0,.281,1.12,1.058,1.058,0,0,0,.952.564,1.043,1.043,0,0,0,.94-.574,2.125,2.125,0,0,0,.292-1.128m6.72,2.362h-1.046v-2.7q0-1.248-.95-1.248a.94.94,0,0,0-.757.343,1.21,1.21,0,0,0-.29.807v2.8h-1.05v-3.37c0-.414-.013-.863-.037-1.35h.92l.05.738h.028a1.531,1.531,0,0,1,.543-.57,1.779,1.779,0,0,1,.953-.263,1.5,1.5,0,0,1,1.1.427,2.073,2.073,0,0,1,.543,1.56v2.826m7.052-3.928h-1.155v2.29q0,.873.611.873a1.793,1.793,0,0,0,.467-.05l.028.8a2.375,2.375,0,0,1-.815.117,1.253,1.253,0,0,1-.968-.377,1.842,1.842,0,0,1-.349-1.27v-2.386h-.7v-.784h.691v-.864l1.027-.31v1.174h1.154v.785m5.548,3.929h-1.049v-2.68q0-1.269-.951-1.268a1,1,0,0,0-1,.735,1.314,1.314,0,0,0-.05.38v2.834h-1.045v-6.879h1.045v2.842h.021a1.581,1.581,0,0,1,1.415-.775,1.464,1.464,0,0,1,1.08.427,2.145,2.145,0,0,1,.532,1.58v2.8m5.723-2.58a2.525,2.525,0,0,1-.04.475h-3.141a1.368,1.368,0,0,0,.454,1.066,1.559,1.559,0,0,0,1.029.33,3.472,3.472,0,0,0,1.271-.223l.164.727a3.952,3.952,0,0,1-1.582.29,2.278,2.278,0,0,1-1.719-.644,2.366,2.366,0,0,1-.626-1.73,2.7,2.7,0,0,1,.582-1.777,2,2,0,0,1,1.648-.757,1.757,1.757,0,0,1,1.542.756,2.551,2.551,0,0,1,.417,1.484Zm-1-.272a1.421,1.421,0,0,0-.2-.8.919.919,0,0,0-.834-.437,1,1,0,0,0-.834.427,1.577,1.577,0,0,0-.311.815h2.182Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->
									<!--<img class="img-fluid" src="assets/images/icons/app-store.png" alt="TRC" />-->
								</a>
								<a
									href="https://play.google.com/store/apps/details?id=io.ionic.raceclub&hl=en_AU&gl=US"
									target="_blank"
								>
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="134.743"
											height="40.115"
											viewBox="0 0 134.743 40.115"
										>
											<g
												id="Group_9319"
												data-name="Group 9319"
												transform="translate(-88.013 101.336)"
											>
												<g id="Group_9319-2" data-name="Group 9319">
													<path
														id="Path_8447"
														data-name="Path 8447"
														d="M143.061-89.6h-2.417l-.58,1.714H139.04l2.289-6.342h1.064l2.289,6.342h-1.041Zm-2.167-.791h1.916l-.944-2.782h-.027Z"
														fill="#fff"
													/>
													<path
														id="Path_8448"
														data-name="Path 8448"
														d="M147.577-87.883h-1.02l-1.665-4.623H145.9l1.16,3.695h.017l1.161-3.695h.993Z"
														fill="#fff"
													/>
													<path
														id="Path_8449"
														data-name="Path 8449"
														d="M149.735-89.2c0-.809.619-1.306,1.718-1.367l1.266-.075V-91c0-.514-.348-.822-.928-.822a.885.885,0,0,0-.975.677h-.9c.053-.835.765-1.45,1.908-1.45,1.12,0,1.836.593,1.836,1.521v3.186h-.909v-.761h-.022a1.653,1.653,0,0,1-1.459.84A1.4,1.4,0,0,1,149.735-89.2Zm2.984-.418v-.365l-1.139.071c-.566.039-.887.29-.887.685s.334.668.843.668A1.109,1.109,0,0,0,152.719-89.615Z"
														fill="#fff"
													/>
													<path
														id="Path_8450"
														data-name="Path 8450"
														d="M154.85-93.8a.546.546,0,0,1,.55-.545.542.542,0,0,1,.545.545.545.545,0,0,1-.545.544A.549.549,0,0,1,154.85-93.8Zm.075,1.292h.949v4.623h-.949Z"
														fill="#fff"
													/>
													<path
														id="Path_8451"
														data-name="Path 8451"
														d="M157.186-94.225h.95v6.342h-.95Z"
														fill="#fff"
													/>
													<path
														id="Path_8452"
														data-name="Path 8452"
														d="M159.217-89.2c0-.809.619-1.306,1.718-1.367l1.266-.075V-91c0-.514-.348-.822-.928-.822a.885.885,0,0,0-.975.677h-.9c.053-.835.765-1.45,1.907-1.45,1.121,0,1.837.593,1.837,1.521v3.186h-.909v-.761h-.022a1.653,1.653,0,0,1-1.459.84A1.4,1.4,0,0,1,159.217-89.2Zm2.984-.418v-.365l-1.139.071c-.567.039-.887.29-.887.685s.334.668.843.668A1.109,1.109,0,0,0,162.2-89.615Z"
														fill="#fff"
													/>
													<path
														id="Path_8453"
														data-name="Path 8453"
														d="M165.362-88.67h-.018v.787h-.923v-6.342h.949v2.5h.022a1.586,1.586,0,0,1,1.459-.861c1.165,0,1.925.923,1.925,2.386s-.756,2.391-1.929,2.391A1.614,1.614,0,0,1,165.362-88.67Zm0-1.525c0,.962.505,1.586,1.226,1.586.747,0,1.209-.606,1.209-1.586s-.462-1.586-1.209-1.586C165.871-91.781,165.366-91.149,165.366-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8454"
														data-name="Path 8454"
														d="M169.871-94.225h.95v6.342h-.95Z"
														fill="#fff"
													/>
													<path
														id="Path_8455"
														data-name="Path 8455"
														d="M176.082-89.241a1.865,1.865,0,0,1-1.99,1.445,2.116,2.116,0,0,1-2.18-2.377,2.153,2.153,0,0,1,2.14-2.417,2.055,2.055,0,0,1,2.083,2.307v.325H172.87v.057a1.212,1.212,0,0,0,1.244,1.336,1.049,1.049,0,0,0,1.068-.676Zm-3.208-1.38h2.312a1.135,1.135,0,0,0-1.134-1.2A1.193,1.193,0,0,0,172.874-90.621Z"
														fill="#fff"
													/>
													<path
														id="Path_8456"
														data-name="Path 8456"
														d="M179.125-92.506h.9v.773h.022a1.5,1.5,0,0,1,1.455-.853,1.523,1.523,0,0,1,1.6,1.71v2.993h-.954v-2.809c0-.694-.325-1.076-.984-1.076a1.078,1.078,0,0,0-1.1,1.191v2.694h-.949Z"
														fill="#fff"
													/>
													<path
														id="Path_8457"
														data-name="Path 8457"
														d="M184.139-90.195a2.147,2.147,0,0,1,2.192-2.395,2.147,2.147,0,0,1,2.193,2.395,2.146,2.146,0,0,1-2.193,2.4A2.146,2.146,0,0,1,184.139-90.195Zm3.418,0c0-1.024-.483-1.613-1.226-1.613s-1.226.589-1.226,1.613.484,1.617,1.226,1.617S187.557-89.167,187.557-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8458"
														data-name="Path 8458"
														d="M194.281-87.883h-.989l-.971-3.463H192.3l-.962,3.463h-.98l-1.27-4.623h.949l.844,3.638h.017l.963-3.638h.914l.967,3.638h.022l.843-3.638h.941Z"
														fill="#fff"
													/>
													<path
														id="Path_8459"
														data-name="Path 8459"
														d="M198.66-91.755h-.638V-92.5h.638v-.452c0-.9.421-1.319,1.362-1.319a3.4,3.4,0,0,1,.532.044v.7a2.068,2.068,0,0,0-.348-.026.537.537,0,0,0-.606.615v.435h.936v.743h-.923v3.872h-.953Z"
														fill="#fff"
													/>
													<path
														id="Path_8460"
														data-name="Path 8460"
														d="M201.212-90.195A2.147,2.147,0,0,1,203.4-92.59a2.148,2.148,0,0,1,2.193,2.395,2.146,2.146,0,0,1-2.193,2.4A2.146,2.146,0,0,1,201.212-90.195Zm3.419,0c0-1.024-.484-1.613-1.226-1.613s-1.226.589-1.226,1.613.483,1.617,1.226,1.617S204.631-89.167,204.631-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8461"
														data-name="Path 8461"
														d="M206.664-92.506h.9v.786h.022a1.114,1.114,0,0,1,1.112-.861,1.747,1.747,0,0,1,.325.035v.883a1.389,1.389,0,0,0-.426-.052.953.953,0,0,0-.989,1.063v2.769h-.949Z"
														fill="#fff"
													/>
												</g>
												<path
													id="Path_395"
													data-name="Path 395"
													d="M216.238-61.221H94.793a6.791,6.791,0,0,1-6.78-6.785V-94.553a6.787,6.787,0,0,1,6.78-6.783H216.238a6.582,6.582,0,0,1,6.518,6.647c0,.045,0,.091,0,.136v27.2c0,3.608-2.679,6.127-6.516,6.127ZM94.793-100.336a5.79,5.79,0,0,0-5.78,5.783v26.547a5.788,5.788,0,0,0,5.78,5.784H216.238c3.3,0,5.516-2.06,5.516-5.128v-27.2a5.594,5.594,0,0,0-5.4-5.78l-.116,0Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
												<g id="Group_9320" data-name="Group 9320">
													<path
														id="Path_8462"
														data-name="Path 8462"
														d="M144.437-83.252h-1.555L137.7-69.85h1.85l1.271-3.452h5.615l1.252,3.452h1.851Zm-3.057,8.427,2.247-6.1h.055l2.209,6.1Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8463"
														data-name="Path 8463"
														d="M152.732-79.815l.13,1.482a3.616,3.616,0,0,1,1.249-1.228A3.331,3.331,0,0,1,155.819-80a3.248,3.248,0,0,1,2.494.944,4.141,4.141,0,0,1,.883,2.916v6.287h-1.815V-76.1a2.7,2.7,0,0,0-.52-1.868,2.085,2.085,0,0,0-1.588-.553,2.547,2.547,0,0,0-1.386.379,2.728,2.728,0,0,0-.962,1.03v7.263h-1.814v-9.961h1.62"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8464"
														data-name="Path 8464"
														d="M168.1-84.211v5.482a3.2,3.2,0,0,0-1.155-.94,3.564,3.564,0,0,0-1.552-.321,3.3,3.3,0,0,0-2.876,1.47,6.637,6.637,0,0,0-1.029,3.875v.193a5.483,5.483,0,0,0,1.032,3.475,3.418,3.418,0,0,0,2.854,1.321,3.589,3.589,0,0,0,1.648-.361,3.235,3.235,0,0,0,1.2-1.058l.212,1.224h1.483v-14.36Zm0,11.683a2.751,2.751,0,0,1-.9,1.031,2.4,2.4,0,0,1-1.363.368,2.152,2.152,0,0,1-1.916-.906,4.212,4.212,0,0,1-.618-2.416h0v-.194a5.563,5.563,0,0,1,.621-2.8,2.076,2.076,0,0,1,1.93-1.078,2.394,2.394,0,0,1,1.338.365,2.817,2.817,0,0,1,.91.979Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8465"
														data-name="Path 8465"
														d="M177.406-78.208l-.93-.057a2.085,2.085,0,0,0-1.21.341,2.18,2.18,0,0,0-.758.958v7.115h-1.815v-9.96h1.62l.176,1.455a3.471,3.471,0,0,1,1.044-1.2,2.448,2.448,0,0,1,1.432-.433,2.182,2.182,0,0,1,.387.033,2.266,2.266,0,0,1,.3.069l-.25,1.684"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8466"
														data-name="Path 8466"
														d="M186.34-78.569A4.056,4.056,0,0,0,183.067-80a4.013,4.013,0,0,0-3.249,1.432,5.48,5.48,0,0,0-1.2,3.64l0,.206a5.446,5.446,0,0,0,1.2,3.641c.072.077.147.153.225.225a4.455,4.455,0,0,0,6.295-.225,5.456,5.456,0,0,0,1.2-3.644v-.2A5.464,5.464,0,0,0,186.34-78.569Zm-.613,3.844a4.684,4.684,0,0,1-.672,2.611,2.45,2.45,0,0,1-.588.588,2.416,2.416,0,0,1-3.366-.588,4.716,4.716,0,0,1-.666-2.611h0v-.2a4.716,4.716,0,0,1,.666-2.6,2.186,2.186,0,0,1,1.965-1.038,2.216,2.216,0,0,1,1.985,1.039,4.678,4.678,0,0,1,.677,2.6Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<rect
														id="Rectangle_2575"
														data-name="Rectangle 2575"
														width="1.815"
														height="1.851"
														transform="translate(189.984 -84.211)"
														fill="#fff"
													/>
													<rect
														id="Rectangle_2576"
														data-name="Rectangle 2576"
														width="1.815"
														height="9.96"
														transform="translate(189.984 -79.811)"
														fill="#fff"
													/>
													<path
														id="Path_8467"
														data-name="Path 8467"
														d="M200.857-84.211v5.482a3.2,3.2,0,0,0-1.155-.94,3.563,3.563,0,0,0-1.551-.321,3.306,3.306,0,0,0-2.88,1.468,6.654,6.654,0,0,0-1.027,3.875h0v.194a5.484,5.484,0,0,0,1.034,3.475,3.423,3.423,0,0,0,2.854,1.321,3.6,3.6,0,0,0,1.648-.361,3.225,3.225,0,0,0,1.2-1.058l.213,1.224h1.482v-14.36Zm0,11.681a2.751,2.751,0,0,1-.9,1.031,2.4,2.4,0,0,1-1.362.369,2.158,2.158,0,0,1-1.917-.907,4.232,4.232,0,0,1-.615-2.416v-.194a5.553,5.553,0,0,1,.622-2.8,2.072,2.072,0,0,1,1.928-1.077,2.382,2.382,0,0,1,1.339.365,2.791,2.791,0,0,1,.907.979Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
												</g>
												<g id="Group_9321" data-name="Group 9321">
													<path
														id="Path_8468"
														data-name="Path 8468"
														d="M103.021-84.92a1.366,1.366,0,0,0-1.365,1.366v5.72a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-5.72a1.366,1.366,0,0,0-1.367-1.366"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8469"
														data-name="Path 8469"
														d="M104.921-75.8a1.454,1.454,0,0,0,1.448,1.458h1v3.027a1.365,1.365,0,0,0,1.328,1.4,1.365,1.365,0,0,0,1.4-1.328c0-.024,0-.049,0-.073v-3.028h1.843v3.026a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-3.025h1A1.458,1.458,0,0,0,117.13-75.8h0v-8.863H104.921V-75.8"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8470"
														data-name="Path 8470"
														d="M119.021-84.921a1.366,1.366,0,0,0-1.364,1.366v5.717a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-5.719a1.362,1.362,0,0,0-1.363-1.365h0"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8471"
														data-name="Path 8471"
														d="M104.92-84.665V-75.8a1.456,1.456,0,0,0,1.454,1.456h1v3.027a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-3.024h1.842v3.024a1.366,1.366,0,0,0,1.366,1.366,1.365,1.365,0,0,0,1.366-1.366v-3.023h1a1.458,1.458,0,0,0,1.458-1.458v-8.863H104.923Z"
														fill="#fff"
													/>
													<path
														id="Path_8472"
														data-name="Path 8472"
														d="M103.025-84.924h0a1.365,1.365,0,0,0-1.365,1.366v5.719a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-5.714A1.366,1.366,0,0,0,103.025-84.924Z"
														fill="#fff"
													/>
													<path
														id="Path_8473"
														data-name="Path 8473"
														d="M120.384-83.555a1.364,1.364,0,0,0-1.364-1.366,1.365,1.365,0,0,0-1.366,1.364v5.718a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-5.718Z"
														fill="#fff"
													/>
													<path
														id="Path_8474"
														data-name="Path 8474"
														d="M114.033-90.054h0l.953-1.741a.189.189,0,0,0-.074-.257.191.191,0,0,0-.258.075l-.963,1.76a6.63,6.63,0,0,0-5.345,0l-.963-1.758a.189.189,0,0,0-.256-.077.189.189,0,0,0-.077.256l.953,1.74a5.578,5.578,0,0,0-3.137,4.92h12.3A5.579,5.579,0,0,0,114.033-90.054Zm-5.3,2.173a.516.516,0,0,1-.515.516.515.515,0,0,1-.514-.516h0v0a.515.515,0,0,1,.514-.516.515.515,0,0,1,.515.516v0Zm5.6,0a.517.517,0,0,1-.515.517.517.517,0,0,1-.517-.516h0v0a.517.517,0,0,1,.515-.518.516.516,0,0,1,.517.516v0Z"
														fill="#fff"
													/>
												</g>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->
								</a>
							</div>
						</div>
						<!-- end store_links -->
					</div>
					<!-- end col_contact_links -->

					<div class="col-lg-5 col_play_store_links">
						<div class="store_links d-none d-lg-block">
							<p>Download Racing Central</p>
							<div class="play_store_links">
								<a href="https://apps.apple.com/au/app/the-race-club/id1434221878" target="_blank">
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="134.744"
											height="40.115"
											viewBox="0 0 134.744 40.115"
										>
											<g
												id="Group_9322"
												data-name="Group 9322"
												transform="translate(-88.013 53.58)"
											>
												<rect
													id="Rectangle_2577"
													data-name="Rectangle 2577"
													width="134.742"
													height="40.115"
													transform="translate(88.013 -53.58)"
													fill="none"
												/>
												<path
													id="Path_395"
													data-name="Path 395"
													d="M216.238-13.465H94.793a6.791,6.791,0,0,1-6.78-6.785V-46.8a6.787,6.787,0,0,1,6.78-6.783H216.238a6.582,6.582,0,0,1,6.518,6.646c0,.046,0,.091,0,.137v27.2c0,3.608-2.679,6.127-6.516,6.127ZM94.793-52.58a5.789,5.789,0,0,0-5.78,5.783V-20.25a5.788,5.788,0,0,0,5.78,5.784H216.238c3.3,0,5.516-2.06,5.516-5.128V-46.8a5.594,5.594,0,0,0-5.4-5.78c-.039,0-.077,0-.116,0Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
												<path
													id="Path_396"
													data-name="Path 396"
													d="M117.978-33.431a5.8,5.8,0,0,1,2.761-4.864,5.937,5.937,0,0,0-4.675-2.528c-1.966-.206-3.873,1.177-4.876,1.177-1.023,0-2.566-1.157-4.227-1.123a6.223,6.223,0,0,0-5.24,3.2c-2.267,3.923-.577,9.688,1.594,12.86,1.087,1.55,2.356,3.286,4.016,3.225,1.625-.068,2.233-1.037,4.194-1.037,1.943,0,2.512,1.038,4.207,1,1.743-.028,2.843-1.56,3.889-3.127A12.864,12.864,0,0,0,121.4-28.28a5.6,5.6,0,0,1-3.42-5.154m-3.2-9.478A5.716,5.716,0,0,0,116.088-47a5.807,5.807,0,0,0-3.758,1.945,5.427,5.427,0,0,0-1.34,3.938,4.8,4.8,0,0,0,3.792-1.793m26.716,21.2h-2.27l-1.243-3.91h-4.328l-1.185,3.91h-2.21l4.283-13.308h2.646l4.3,13.308Zm-3.889-5.55-1.125-3.474q-.177-.531-.671-2.506h-.039q-.2.849-.633,2.507l-1.1,3.476h3.574Zm14.907.635a5.458,5.458,0,0,1-1.322,3.868,3.871,3.871,0,0,1-2.943,1.263,2.938,2.938,0,0,1-2.724-1.36h-.038V-17.8h-2.137V-28.147q0-1.539-.079-3.16h1.876l.117,1.52h.041a3.8,3.8,0,0,1,5.262-1.091,3.826,3.826,0,0,1,.809.715,5.307,5.307,0,0,1,1.135,3.537Zm-2.17.077a3.966,3.966,0,0,0-.633-2.31,2.184,2.184,0,0,0-1.856-.948,2.206,2.206,0,0,0-1.43.522,2.415,2.415,0,0,0-.84,1.373,2.7,2.7,0,0,0-.1.65v1.6a2.558,2.558,0,0,0,.64,1.768,2.133,2.133,0,0,0,1.67.72,2.188,2.188,0,0,0,1.875-.927,4.106,4.106,0,0,0,.672-2.45Zm13.207-.077a5.455,5.455,0,0,1-1.324,3.868,3.868,3.868,0,0,1-2.94,1.263,2.94,2.94,0,0,1-2.725-1.36h-.04V-17.8h-2.135V-28.147q0-1.539-.081-3.16h1.878l.12,1.52h.038a3.8,3.8,0,0,1,5.262-1.092,3.836,3.836,0,0,1,.81.716,5.309,5.309,0,0,1,1.135,3.537Zm-2.172.077a3.951,3.951,0,0,0-.633-2.31,2.181,2.181,0,0,0-1.855-.948,2.21,2.21,0,0,0-1.431.522,2.414,2.414,0,0,0-.839,1.373,2.8,2.8,0,0,0-.1.65v1.6a2.554,2.554,0,0,0,.64,1.768,2.124,2.124,0,0,0,1.669.72,2.187,2.187,0,0,0,1.874-.927,4.1,4.1,0,0,0,.672-2.45Zm14.512,1.106a3.552,3.552,0,0,1-1.18,2.764,5.25,5.25,0,0,1-3.626,1.165,6.345,6.345,0,0,1-3.45-.83l.5-1.777a5.832,5.832,0,0,0,3.082.85,2.917,2.917,0,0,0,1.877-.544,1.77,1.77,0,0,0,.67-1.453,1.85,1.85,0,0,0-.553-1.364,5.151,5.151,0,0,0-1.835-1.03q-3.5-1.3-3.5-3.816a3.384,3.384,0,0,1,1.225-2.69,4.83,4.83,0,0,1,3.258-1.048,6.455,6.455,0,0,1,3.019.63l-.532,1.74a5.216,5.216,0,0,0-2.548-.613,2.564,2.564,0,0,0-1.755.553,1.581,1.581,0,0,0-.532,1.2,1.625,1.625,0,0,0,.61,1.3,6.9,6.9,0,0,0,1.936,1.027,6.547,6.547,0,0,1,2.529,1.62,3.406,3.406,0,0,1,.808,2.31m7.046-4.266h-2.354v4.66q0,1.777,1.245,1.777a3.791,3.791,0,0,0,.949-.1l.059,1.62a4.816,4.816,0,0,1-1.659.237,2.558,2.558,0,0,1-1.975-.77,3.784,3.784,0,0,1-.71-2.587v-4.828h-1.4v-1.6h1.4v-1.756l2.093-.632v2.39h2.351v1.6m10.6,3.12a5.277,5.277,0,0,1-1.263,3.633,4.514,4.514,0,0,1-3.516,1.46,4.286,4.286,0,0,1-3.365-1.4,5.1,5.1,0,0,1-1.254-3.534,5.21,5.21,0,0,1,1.295-3.654,4.47,4.47,0,0,1,3.484-1.42,4.384,4.384,0,0,1,3.4,1.4,5.07,5.07,0,0,1,1.224,3.515Zm-2.213.07a4.326,4.326,0,0,0-.572-2.278,2.109,2.109,0,0,0-1.915-1.15,2.136,2.136,0,0,0-1.954,1.15,4.395,4.395,0,0,0-.574,2.313,4.3,4.3,0,0,0,.572,2.276,2.178,2.178,0,0,0,2.948.892,2.181,2.181,0,0,0,.9-.912,4.336,4.336,0,0,0,.591-2.3Zm9.144-2.914a3.633,3.633,0,0,0-.674-.06,2.015,2.015,0,0,0-1.737.85,3.181,3.181,0,0,0-.534,1.9V-21.7H195.4l.019-6.575q0-1.659-.082-3.02h1.859l.078,1.835h.059a3.268,3.268,0,0,1,1.066-1.52,2.579,2.579,0,0,1,1.54-.513,3.2,3.2,0,0,1,.535.04v2.032m9.534,2.47a5.126,5.126,0,0,1-.076.966h-6.4a2.785,2.785,0,0,0,.927,2.173,3.167,3.167,0,0,0,2.09.669,7.1,7.1,0,0,0,2.591-.453l.333,1.48a8.024,8.024,0,0,1-3.217.592,4.653,4.653,0,0,1-3.505-1.313,4.844,4.844,0,0,1-1.274-3.526,5.5,5.5,0,0,1,1.185-3.613,4.1,4.1,0,0,1,3.357-1.538,3.573,3.573,0,0,1,3.14,1.54,5.189,5.189,0,0,1,.847,3.02Zm-2.032-.553a2.9,2.9,0,0,0-.413-1.639,1.867,1.867,0,0,0-1.7-.888,2.024,2.024,0,0,0-1.7.87,3.161,3.161,0,0,0-.629,1.657h4.442Zm-71.07-15.7a3.283,3.283,0,0,1-1.06,2.658,4.2,4.2,0,0,1-2.783.824,13.057,13.057,0,0,1-1.532-.078v-6.43a11.179,11.179,0,0,1,1.8-.137,3.9,3.9,0,0,1,2.591.747,3.031,3.031,0,0,1,.98,2.416Zm-1.107.03a2.394,2.394,0,0,0-.606-1.757,2.389,2.389,0,0,0-1.77-.61,4.509,4.509,0,0,0-.845.067v4.89a6.191,6.191,0,0,0,.708.028,2.483,2.483,0,0,0,1.858-.67,2.684,2.684,0,0,0,.655-1.95Zm6.964,1a2.593,2.593,0,0,1-.62,1.785,2.226,2.226,0,0,1-1.728.718,2.116,2.116,0,0,1-1.655-.688,2.513,2.513,0,0,1-.616-1.737,2.551,2.551,0,0,1,.636-1.794,2.2,2.2,0,0,1,1.71-.7,2.157,2.157,0,0,1,1.67.688,2.5,2.5,0,0,1,.6,1.728Zm-1.087.034a2.151,2.151,0,0,0-.281-1.12,1.036,1.036,0,0,0-.941-.563,1.049,1.049,0,0,0-.96.563,2.149,2.149,0,0,0-.282,1.138,2.114,2.114,0,0,0,.282,1.12,1.055,1.055,0,0,0,.95.564,1.043,1.043,0,0,0,.94-.574,2.116,2.116,0,0,0,.292-1.128m8.94-2.354-1.472,4.715h-.959l-.612-2.047a14.542,14.542,0,0,1-.38-1.523h-.017a11.227,11.227,0,0,1-.38,1.523l-.649,2.047h-.969l-1.389-4.715h1.077l.535,2.24c.13.53.235,1.035.32,1.513h.02q.114-.591.386-1.5l.671-2.25h.853l.639,2.2c.157.536.281,1.054.378,1.55h.031a13.878,13.878,0,0,1,.32-1.55l.572-2.2h1.025m5.436,4.712H155v-2.7q0-1.248-.95-1.248a.944.944,0,0,0-.757.343,1.21,1.21,0,0,0-.29.807v2.8h-1.049v-3.37c0-.414-.012-.863-.037-1.35h.92l.05.738h.03a1.5,1.5,0,0,1,.542-.57,1.766,1.766,0,0,1,.95-.263,1.5,1.5,0,0,1,1.1.427,2.077,2.077,0,0,1,.543,1.56v2.826m1.84-6.879h1.046v6.879h-1.046Zm7.22,4.479a2.593,2.593,0,0,1-.62,1.785,2.226,2.226,0,0,1-1.727.718,2.111,2.111,0,0,1-1.656-.688,2.507,2.507,0,0,1-.615-1.737,2.565,2.565,0,0,1,.633-1.794,2.2,2.2,0,0,1,1.71-.7,2.157,2.157,0,0,1,1.67.688,2.5,2.5,0,0,1,.6,1.728Zm-1.088.034a2.162,2.162,0,0,0-.28-1.12,1.084,1.084,0,0,0-1.472-.428,1.075,1.075,0,0,0-.428.428,2.14,2.14,0,0,0-.282,1.138,2.125,2.125,0,0,0,.281,1.12,1.055,1.055,0,0,0,.95.564,1.045,1.045,0,0,0,.941-.574A2.115,2.115,0,0,0,164.025-42.146Zm6.16,2.362h-.94l-.08-.543h-.031a1.6,1.6,0,0,1-1.375.65,1.422,1.422,0,0,1-1.076-.426,1.343,1.343,0,0,1-.37-.96,1.466,1.466,0,0,1,.724-1.32,3.754,3.754,0,0,1,2.033-.446v-.087q0-.93-.979-.93a2.174,2.174,0,0,0-1.229.35l-.212-.69a3.018,3.018,0,0,1,1.613-.4q1.848,0,1.85,1.95V-40.9a7.158,7.158,0,0,0,.068,1.124ZM169.1-41.4v-.727q-1.732-.03-1.733.95a.711.711,0,0,0,.2.553.74.74,0,0,0,.513.184,1.057,1.057,0,0,0,.639-.218.893.893,0,0,0,.364-.558,1.132,1.132,0,0,0,.016-.184Zm7.044,1.62h-.931l-.047-.757h-.031a1.564,1.564,0,0,1-1.512.864,1.763,1.763,0,0,1-1.416-.67,2.6,2.6,0,0,1-.563-1.735,2.727,2.727,0,0,1,.611-1.853,1.877,1.877,0,0,1,1.456-.66,1.417,1.417,0,0,1,1.328.64h.019v-2.7H176.1v5.607q0,.69.037,1.27m-1.087-1.99v-.785a1.583,1.583,0,0,0-.029-.33,1.192,1.192,0,0,0-.378-.635,1.026,1.026,0,0,0-.7-.258,1.073,1.073,0,0,0-.922.466,1.991,1.991,0,0,0-.336,1.193,1.857,1.857,0,0,0,.322,1.135,1.08,1.08,0,0,0,.916.467,1.017,1.017,0,0,0,.827-.388,1.305,1.305,0,0,0,.3-.865Zm10.05-.406a2.593,2.593,0,0,1-.62,1.785,2.224,2.224,0,0,1-1.729.718,2.113,2.113,0,0,1-1.653-.688,2.507,2.507,0,0,1-.615-1.737,2.557,2.557,0,0,1,.627-1.794,2.2,2.2,0,0,1,1.713-.7,2.154,2.154,0,0,1,1.667.688,2.493,2.493,0,0,1,.6,1.728Zm-1.09.034a2.162,2.162,0,0,0-.28-1.12,1.041,1.041,0,0,0-.943-.563,1.049,1.049,0,0,0-.96.563,2.14,2.14,0,0,0-.282,1.138,2.125,2.125,0,0,0,.281,1.12,1.058,1.058,0,0,0,.952.564,1.043,1.043,0,0,0,.94-.574,2.125,2.125,0,0,0,.292-1.128m6.72,2.362h-1.046v-2.7q0-1.248-.95-1.248a.94.94,0,0,0-.757.343,1.21,1.21,0,0,0-.29.807v2.8h-1.05v-3.37c0-.414-.013-.863-.037-1.35h.92l.05.738h.028a1.531,1.531,0,0,1,.543-.57,1.779,1.779,0,0,1,.953-.263,1.5,1.5,0,0,1,1.1.427,2.073,2.073,0,0,1,.543,1.56v2.826m7.052-3.928h-1.155v2.29q0,.873.611.873a1.793,1.793,0,0,0,.467-.05l.028.8a2.375,2.375,0,0,1-.815.117,1.253,1.253,0,0,1-.968-.377,1.842,1.842,0,0,1-.349-1.27v-2.386h-.7v-.784h.691v-.864l1.027-.31v1.174h1.154v.785m5.548,3.929h-1.049v-2.68q0-1.269-.951-1.268a1,1,0,0,0-1,.735,1.314,1.314,0,0,0-.05.38v2.834h-1.045v-6.879h1.045v2.842h.021a1.581,1.581,0,0,1,1.415-.775,1.464,1.464,0,0,1,1.08.427,2.145,2.145,0,0,1,.532,1.58v2.8m5.723-2.58a2.525,2.525,0,0,1-.04.475h-3.141a1.368,1.368,0,0,0,.454,1.066,1.559,1.559,0,0,0,1.029.33,3.472,3.472,0,0,0,1.271-.223l.164.727a3.952,3.952,0,0,1-1.582.29,2.278,2.278,0,0,1-1.719-.644,2.366,2.366,0,0,1-.626-1.73,2.7,2.7,0,0,1,.582-1.777,2,2,0,0,1,1.648-.757,1.757,1.757,0,0,1,1.542.756,2.551,2.551,0,0,1,.417,1.484Zm-1-.272a1.421,1.421,0,0,0-.2-.8.919.919,0,0,0-.834-.437,1,1,0,0,0-.834.427,1.577,1.577,0,0,0-.311.815h2.182Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->
									<!--<img class="img-fluid" src="assets/images/icons/app-store.png" alt="TRC" />-->
								</a>
								<a
									href="https://play.google.com/store/apps/details?id=io.ionic.raceclub&hl=en_AU&gl=US"
									target="_blank"
								>
									<div class="svg_wrapper">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="134.743"
											height="40.115"
											viewBox="0 0 134.743 40.115"
										>
											<g
												id="Group_9319"
												data-name="Group 9319"
												transform="translate(-88.013 101.336)"
											>
												<g id="Group_9319-2" data-name="Group 9319">
													<path
														id="Path_8447"
														data-name="Path 8447"
														d="M143.061-89.6h-2.417l-.58,1.714H139.04l2.289-6.342h1.064l2.289,6.342h-1.041Zm-2.167-.791h1.916l-.944-2.782h-.027Z"
														fill="#fff"
													/>
													<path
														id="Path_8448"
														data-name="Path 8448"
														d="M147.577-87.883h-1.02l-1.665-4.623H145.9l1.16,3.695h.017l1.161-3.695h.993Z"
														fill="#fff"
													/>
													<path
														id="Path_8449"
														data-name="Path 8449"
														d="M149.735-89.2c0-.809.619-1.306,1.718-1.367l1.266-.075V-91c0-.514-.348-.822-.928-.822a.885.885,0,0,0-.975.677h-.9c.053-.835.765-1.45,1.908-1.45,1.12,0,1.836.593,1.836,1.521v3.186h-.909v-.761h-.022a1.653,1.653,0,0,1-1.459.84A1.4,1.4,0,0,1,149.735-89.2Zm2.984-.418v-.365l-1.139.071c-.566.039-.887.29-.887.685s.334.668.843.668A1.109,1.109,0,0,0,152.719-89.615Z"
														fill="#fff"
													/>
													<path
														id="Path_8450"
														data-name="Path 8450"
														d="M154.85-93.8a.546.546,0,0,1,.55-.545.542.542,0,0,1,.545.545.545.545,0,0,1-.545.544A.549.549,0,0,1,154.85-93.8Zm.075,1.292h.949v4.623h-.949Z"
														fill="#fff"
													/>
													<path
														id="Path_8451"
														data-name="Path 8451"
														d="M157.186-94.225h.95v6.342h-.95Z"
														fill="#fff"
													/>
													<path
														id="Path_8452"
														data-name="Path 8452"
														d="M159.217-89.2c0-.809.619-1.306,1.718-1.367l1.266-.075V-91c0-.514-.348-.822-.928-.822a.885.885,0,0,0-.975.677h-.9c.053-.835.765-1.45,1.907-1.45,1.121,0,1.837.593,1.837,1.521v3.186h-.909v-.761h-.022a1.653,1.653,0,0,1-1.459.84A1.4,1.4,0,0,1,159.217-89.2Zm2.984-.418v-.365l-1.139.071c-.567.039-.887.29-.887.685s.334.668.843.668A1.109,1.109,0,0,0,162.2-89.615Z"
														fill="#fff"
													/>
													<path
														id="Path_8453"
														data-name="Path 8453"
														d="M165.362-88.67h-.018v.787h-.923v-6.342h.949v2.5h.022a1.586,1.586,0,0,1,1.459-.861c1.165,0,1.925.923,1.925,2.386s-.756,2.391-1.929,2.391A1.614,1.614,0,0,1,165.362-88.67Zm0-1.525c0,.962.505,1.586,1.226,1.586.747,0,1.209-.606,1.209-1.586s-.462-1.586-1.209-1.586C165.871-91.781,165.366-91.149,165.366-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8454"
														data-name="Path 8454"
														d="M169.871-94.225h.95v6.342h-.95Z"
														fill="#fff"
													/>
													<path
														id="Path_8455"
														data-name="Path 8455"
														d="M176.082-89.241a1.865,1.865,0,0,1-1.99,1.445,2.116,2.116,0,0,1-2.18-2.377,2.153,2.153,0,0,1,2.14-2.417,2.055,2.055,0,0,1,2.083,2.307v.325H172.87v.057a1.212,1.212,0,0,0,1.244,1.336,1.049,1.049,0,0,0,1.068-.676Zm-3.208-1.38h2.312a1.135,1.135,0,0,0-1.134-1.2A1.193,1.193,0,0,0,172.874-90.621Z"
														fill="#fff"
													/>
													<path
														id="Path_8456"
														data-name="Path 8456"
														d="M179.125-92.506h.9v.773h.022a1.5,1.5,0,0,1,1.455-.853,1.523,1.523,0,0,1,1.6,1.71v2.993h-.954v-2.809c0-.694-.325-1.076-.984-1.076a1.078,1.078,0,0,0-1.1,1.191v2.694h-.949Z"
														fill="#fff"
													/>
													<path
														id="Path_8457"
														data-name="Path 8457"
														d="M184.139-90.195a2.147,2.147,0,0,1,2.192-2.395,2.147,2.147,0,0,1,2.193,2.395,2.146,2.146,0,0,1-2.193,2.4A2.146,2.146,0,0,1,184.139-90.195Zm3.418,0c0-1.024-.483-1.613-1.226-1.613s-1.226.589-1.226,1.613.484,1.617,1.226,1.617S187.557-89.167,187.557-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8458"
														data-name="Path 8458"
														d="M194.281-87.883h-.989l-.971-3.463H192.3l-.962,3.463h-.98l-1.27-4.623h.949l.844,3.638h.017l.963-3.638h.914l.967,3.638h.022l.843-3.638h.941Z"
														fill="#fff"
													/>
													<path
														id="Path_8459"
														data-name="Path 8459"
														d="M198.66-91.755h-.638V-92.5h.638v-.452c0-.9.421-1.319,1.362-1.319a3.4,3.4,0,0,1,.532.044v.7a2.068,2.068,0,0,0-.348-.026.537.537,0,0,0-.606.615v.435h.936v.743h-.923v3.872h-.953Z"
														fill="#fff"
													/>
													<path
														id="Path_8460"
														data-name="Path 8460"
														d="M201.212-90.195A2.147,2.147,0,0,1,203.4-92.59a2.148,2.148,0,0,1,2.193,2.395,2.146,2.146,0,0,1-2.193,2.4A2.146,2.146,0,0,1,201.212-90.195Zm3.419,0c0-1.024-.484-1.613-1.226-1.613s-1.226.589-1.226,1.613.483,1.617,1.226,1.617S204.631-89.167,204.631-90.195Z"
														fill="#fff"
													/>
													<path
														id="Path_8461"
														data-name="Path 8461"
														d="M206.664-92.506h.9v.786h.022a1.114,1.114,0,0,1,1.112-.861,1.747,1.747,0,0,1,.325.035v.883a1.389,1.389,0,0,0-.426-.052.953.953,0,0,0-.989,1.063v2.769h-.949Z"
														fill="#fff"
													/>
												</g>
												<path
													id="Path_395"
													data-name="Path 395"
													d="M216.238-61.221H94.793a6.791,6.791,0,0,1-6.78-6.785V-94.553a6.787,6.787,0,0,1,6.78-6.783H216.238a6.582,6.582,0,0,1,6.518,6.647c0,.045,0,.091,0,.136v27.2c0,3.608-2.679,6.127-6.516,6.127ZM94.793-100.336a5.79,5.79,0,0,0-5.78,5.783v26.547a5.788,5.788,0,0,0,5.78,5.784H216.238c3.3,0,5.516-2.06,5.516-5.128v-27.2a5.594,5.594,0,0,0-5.4-5.78l-.116,0Z"
													fill="#fff"
													fill-rule="evenodd"
												/>
												<g id="Group_9320" data-name="Group 9320">
													<path
														id="Path_8462"
														data-name="Path 8462"
														d="M144.437-83.252h-1.555L137.7-69.85h1.85l1.271-3.452h5.615l1.252,3.452h1.851Zm-3.057,8.427,2.247-6.1h.055l2.209,6.1Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8463"
														data-name="Path 8463"
														d="M152.732-79.815l.13,1.482a3.616,3.616,0,0,1,1.249-1.228A3.331,3.331,0,0,1,155.819-80a3.248,3.248,0,0,1,2.494.944,4.141,4.141,0,0,1,.883,2.916v6.287h-1.815V-76.1a2.7,2.7,0,0,0-.52-1.868,2.085,2.085,0,0,0-1.588-.553,2.547,2.547,0,0,0-1.386.379,2.728,2.728,0,0,0-.962,1.03v7.263h-1.814v-9.961h1.62"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8464"
														data-name="Path 8464"
														d="M168.1-84.211v5.482a3.2,3.2,0,0,0-1.155-.94,3.564,3.564,0,0,0-1.552-.321,3.3,3.3,0,0,0-2.876,1.47,6.637,6.637,0,0,0-1.029,3.875v.193a5.483,5.483,0,0,0,1.032,3.475,3.418,3.418,0,0,0,2.854,1.321,3.589,3.589,0,0,0,1.648-.361,3.235,3.235,0,0,0,1.2-1.058l.212,1.224h1.483v-14.36Zm0,11.683a2.751,2.751,0,0,1-.9,1.031,2.4,2.4,0,0,1-1.363.368,2.152,2.152,0,0,1-1.916-.906,4.212,4.212,0,0,1-.618-2.416h0v-.194a5.563,5.563,0,0,1,.621-2.8,2.076,2.076,0,0,1,1.93-1.078,2.394,2.394,0,0,1,1.338.365,2.817,2.817,0,0,1,.91.979Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8465"
														data-name="Path 8465"
														d="M177.406-78.208l-.93-.057a2.085,2.085,0,0,0-1.21.341,2.18,2.18,0,0,0-.758.958v7.115h-1.815v-9.96h1.62l.176,1.455a3.471,3.471,0,0,1,1.044-1.2,2.448,2.448,0,0,1,1.432-.433,2.182,2.182,0,0,1,.387.033,2.266,2.266,0,0,1,.3.069l-.25,1.684"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8466"
														data-name="Path 8466"
														d="M186.34-78.569A4.056,4.056,0,0,0,183.067-80a4.013,4.013,0,0,0-3.249,1.432,5.48,5.48,0,0,0-1.2,3.64l0,.206a5.446,5.446,0,0,0,1.2,3.641c.072.077.147.153.225.225a4.455,4.455,0,0,0,6.295-.225,5.456,5.456,0,0,0,1.2-3.644v-.2A5.464,5.464,0,0,0,186.34-78.569Zm-.613,3.844a4.684,4.684,0,0,1-.672,2.611,2.45,2.45,0,0,1-.588.588,2.416,2.416,0,0,1-3.366-.588,4.716,4.716,0,0,1-.666-2.611h0v-.2a4.716,4.716,0,0,1,.666-2.6,2.186,2.186,0,0,1,1.965-1.038,2.216,2.216,0,0,1,1.985,1.039,4.678,4.678,0,0,1,.677,2.6Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<rect
														id="Rectangle_2575"
														data-name="Rectangle 2575"
														width="1.815"
														height="1.851"
														transform="translate(189.984 -84.211)"
														fill="#fff"
													/>
													<rect
														id="Rectangle_2576"
														data-name="Rectangle 2576"
														width="1.815"
														height="9.96"
														transform="translate(189.984 -79.811)"
														fill="#fff"
													/>
													<path
														id="Path_8467"
														data-name="Path 8467"
														d="M200.857-84.211v5.482a3.2,3.2,0,0,0-1.155-.94,3.563,3.563,0,0,0-1.551-.321,3.306,3.306,0,0,0-2.88,1.468,6.654,6.654,0,0,0-1.027,3.875h0v.194a5.484,5.484,0,0,0,1.034,3.475,3.423,3.423,0,0,0,2.854,1.321,3.6,3.6,0,0,0,1.648-.361,3.225,3.225,0,0,0,1.2-1.058l.213,1.224h1.482v-14.36Zm0,11.681a2.751,2.751,0,0,1-.9,1.031,2.4,2.4,0,0,1-1.362.369,2.158,2.158,0,0,1-1.917-.907,4.232,4.232,0,0,1-.615-2.416v-.194a5.553,5.553,0,0,1,.622-2.8,2.072,2.072,0,0,1,1.928-1.077,2.382,2.382,0,0,1,1.339.365,2.791,2.791,0,0,1,.907.979Z"
														fill="#fff"
														fill-rule="evenodd"
													/>
												</g>
												<g id="Group_9321" data-name="Group 9321">
													<path
														id="Path_8468"
														data-name="Path 8468"
														d="M103.021-84.92a1.366,1.366,0,0,0-1.365,1.366v5.72a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-5.72a1.366,1.366,0,0,0-1.367-1.366"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8469"
														data-name="Path 8469"
														d="M104.921-75.8a1.454,1.454,0,0,0,1.448,1.458h1v3.027a1.365,1.365,0,0,0,1.328,1.4,1.365,1.365,0,0,0,1.4-1.328c0-.024,0-.049,0-.073v-3.028h1.843v3.026a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-3.025h1A1.458,1.458,0,0,0,117.13-75.8h0v-8.863H104.921V-75.8"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8470"
														data-name="Path 8470"
														d="M119.021-84.921a1.366,1.366,0,0,0-1.364,1.366v5.717a1.367,1.367,0,0,0,1.366,1.366,1.366,1.366,0,0,0,1.366-1.366v-5.719a1.362,1.362,0,0,0-1.363-1.365h0"
														fill="#fff"
														fill-rule="evenodd"
													/>
													<path
														id="Path_8471"
														data-name="Path 8471"
														d="M104.92-84.665V-75.8a1.456,1.456,0,0,0,1.454,1.456h1v3.027a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-3.024h1.842v3.024a1.366,1.366,0,0,0,1.366,1.366,1.365,1.365,0,0,0,1.366-1.366v-3.023h1a1.458,1.458,0,0,0,1.458-1.458v-8.863H104.923Z"
														fill="#fff"
													/>
													<path
														id="Path_8472"
														data-name="Path 8472"
														d="M103.025-84.924h0a1.365,1.365,0,0,0-1.365,1.366v5.719a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-5.714A1.366,1.366,0,0,0,103.025-84.924Z"
														fill="#fff"
													/>
													<path
														id="Path_8473"
														data-name="Path 8473"
														d="M120.384-83.555a1.364,1.364,0,0,0-1.364-1.366,1.365,1.365,0,0,0-1.366,1.364v5.718a1.366,1.366,0,0,0,1.366,1.365,1.365,1.365,0,0,0,1.366-1.365v-5.718Z"
														fill="#fff"
													/>
													<path
														id="Path_8474"
														data-name="Path 8474"
														d="M114.033-90.054h0l.953-1.741a.189.189,0,0,0-.074-.257.191.191,0,0,0-.258.075l-.963,1.76a6.63,6.63,0,0,0-5.345,0l-.963-1.758a.189.189,0,0,0-.256-.077.189.189,0,0,0-.077.256l.953,1.74a5.578,5.578,0,0,0-3.137,4.92h12.3A5.579,5.579,0,0,0,114.033-90.054Zm-5.3,2.173a.516.516,0,0,1-.515.516.515.515,0,0,1-.514-.516h0v0a.515.515,0,0,1,.514-.516.515.515,0,0,1,.515.516v0Zm5.6,0a.517.517,0,0,1-.515.517.517.517,0,0,1-.517-.516h0v0a.517.517,0,0,1,.515-.518.516.516,0,0,1,.517.516v0Z"
														fill="#fff"
													/>
												</g>
											</g>
										</svg>
									</div>
									<!-- end svg_wrapper -->
								</a>
							</div>
						</div>
						<!-- end store_links -->

						<!--<div class="betfair_section">
							<div class="svg_wrapper">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="172.492"
									height="29.915"
									viewBox="0 0 172.492 29.915"
								>
									<path
										id="Path_8445"
										data-name="Path 8445"
										d="M47.922,53.708c0-4.842,3.173-5.009,7.347-5.009h.5c4.175,0,6.345.668,6.345,5.343v3.34c0,4.008-1,5.677-6.512,5.677H54.434c-5.176,0-6.679-1.5-6.679-5.343V53.708Zm0,10.52a7.73,7.73,0,0,0,6.679,2.5h1.5c6.011,0,10.52-1.5,10.52-8.516V53.875c0-6.512-2.839-8.85-10.353-8.85H53.933a7.252,7.252,0,0,0-6.011,2.338V37.01H43.413V66.232h4.509Zm74.14-18.7h-6.178V43.689a3.314,3.314,0,0,1,3.173-3.34h5.009V37.01h-6.011a6.156,6.156,0,0,0-6.679,5.51v3.006h-2.5V49.2h2.5V66.733h4.509V49.2h6.178ZM95.679,60.054a6.417,6.417,0,0,0,5.51,6.846h6.846V63.226h-4.508c-2.5,0-3.34-1.336-3.34-3.006V49.367h6.178V45.693h-6.178V37.01H95.679v8.683h-2.5v3.674h2.5Zm52.766-18.368h4.508V37.01h-4.675Zm0,25.047h4.508V45.025h-4.508ZM73.47,53.374c0-4.175,2-4.509,6.679-4.509h1c5.343,0,6.011,1.336,6.011,4.008v1.169H73.637Zm5.009,13.359h4.175c5.51,0,8.015-1.837,8.683-4.842L87.33,60.722c-.668,1.837-2.338,2.338-5.844,2.338h-1c-5.844,0-6.846-.668-6.846-5.343h18.2V53.708c0-7.347-3.841-8.683-9.852-8.683H79.815c-4.842,0-10.52.835-10.52,8.182v5.176c-.334,7.18,4.675,8.349,9.184,8.349m61.282-6.512c0,2-1.336,2.839-6.846,2.839h-1.169c-4.675,0-5.176-.835-5.176-2.672V59.219c0-2,1.169-2.839,5.009-2.839h2c3.507,0,6.178.668,6.178,3.006Zm-5.677-15.2h-1.67c-6.178,0-8.85,1.837-9.017,4.842l4.342,1.5c.167-2,2.5-2.5,5.844-2.5,5.009,0,6.178.334,6.178,4.008v2c-1.169-1.5-2.672-2-6.679-2h-1.837c-5.844,0-9.184,1.5-9.184,6.178v1.336c0,3.841,1.5,6.512,7.514,6.512h4.508c4.342,0,4.842-.668,5.677-2v2h4.509V52.873c0-6.178-4.008-7.848-10.186-7.848m32.9,0a5.871,5.871,0,0,0-5.343,2.839H161.3V45.025h-4.342V66.733h4.508V53.708a4.675,4.675,0,0,1,4.316-5.009h.86c2.5,0,3.841.668,4.008,1.336l2.839-2c-.668-1.837-2.5-3.006-6.512-3.006M34.9,37.01H23.042v6.011H16.7l12.19,14.36,12.19-14.36H34.73ZM1,60.722H7.345v6.011H19.2V60.722h6.345l-12.19-14.36Z"
										transform="translate(-1 -36.985)"
										fill="#fff"
									/>
								</svg>
							</div>
							

							<p>
								Racing Central is proudly endorsed by Betfair Australia. You can access exclusive
								selections through the
								<a href="https://www.betfair.com.au/hub/" target="_blank">Betfair Hub.</a>
							</p>
						</div>-->
						<!-- end betfair_section -->
					</div>
					<!-- end col_play_store_links -->
				</div>
				<!-- end footer_top -->

				<div class="row footer_bottom">
					<div class="col-md-6 footer_copyright">
						<span>Copyright &copy; 2021. Racing Central Australia Pty Ltd</span>
						<a href="/terms-and-conditions">Terms & Conditions</a>
						<a href="/privacy-policy">Privacy Policy</a>
					</div>
					<div class="col-md-6 site_by">
						Powered by <a href="https://pinkpanda.com.au/" target="_blank">Pink Panda</a>
					</div>
				</div>
				<!-- end footer_bottom -->
			</div>
			<!-- end col-lg-10 offset-lg-1 -->
		</div>
		<!-- end row -->
	</div>
	<!-- end container -->
</footer>
<!-- end footer_wrapper -->
